import { render, staticRenderFns } from "./freestyle-order-policy.vue?vue&type=template&id=45c5939a&"
import script from "./freestyle-order-policy.vue?vue&type=script&lang=js&"
export * from "./freestyle-order-policy.vue?vue&type=script&lang=js&"
import style0 from "./freestyle-order-policy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports